<div class="uk-position-relative uk-card uk-card-default uk-border-rounded uk-background-cover" [ngStyle]="{'background-image': 'url('+imagesCard+')'}">
    <a href="/blog/{{linkIDCard}}">
        <div class="uk-overlay-primary uk-position-cover uk-border-rounded"></div>
        <div class="uk-light uk-card-body uk-position-center-left">
            <h3 class="uk-card-title uk-h1">{{titleCard}}</h3>
            <p class="uk-padding-large uk-padding-remove-horizontal uk-padding-remove-top +text-read">{{descriptionCard}}</p>
        </div>
    </a>
    <div class="uk-card-footer uk-flex uk-position-bottom">
        <time class="uk-flex-1 uk-text-muted" [attr.datetime]="timeStampCard">
            <i uk-icon="calendar"></i> {{dateCard}}
        </time>
        <div class="uk-flex-1 uk-text-right uk-light">
            <a href="/blog/{{linkIDCard}}" class="uk-button uk-button-text">เพิ่มเติม <span uk-icon="arrow-right"></span></a>
        </div>
    </div>
</div>